import { useMutation, useQueryClient } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

type ImperativeRequestFn = ReturnType<typeof useImperativeRequestWrapper>[1];

const deleteWebhookConfig =
  ({
    partnerId,
    makeRequest,
  }: {
    partnerId: string;
    makeRequest: ImperativeRequestFn;
  }) =>
  async (configId: string): Promise<void> => {
    const { error } = await makeRequest({
      path: `/partners/${partnerId}/webhooks/configs/${configId}`,
      method: 'delete',
    });
    if (error) throw new Error(error?.message ?? 'Delete failed');
  };

type UseDeleteWebhookConfigOptions = {
  partnerId: string;
  config?: MutationConfig<ReturnType<typeof deleteWebhookConfig>>;
};

export const useDeleteWebhookConfig = ({
  partnerId,
  config,
}: UseDeleteWebhookConfigOptions) => {
  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');
  const queryClient = useQueryClient();

  return useMutation({
    ...config,
    mutationFn: deleteWebhookConfig({ partnerId, makeRequest }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['webhook-configs', partnerId],
      });
    },
  });
};
